import React from 'react';




function UserHome() {
     return (
        <>
        <h3>Hello User</h3>
        </>
     )
  }
export default UserHome;